import { createRouter, createWebHistory } from 'vue-router';
import Login from './views/Login.vue';
import MainLayout from './layouts/MainLayout.vue';
import Dashboard from './views/Dashboard.vue';
import Nodes from './views/Nodes.vue';
import Proxies from './views/Proxies.vue';
import ProxyUsers from './views/ProxyUsers.vue';
import Leaderboard from './views/Leaderboard.vue';
import Topology from './views/Topology.vue';
import RegionLines from './views/RegionLines.vue';
import Settings from './views/Settings.vue';
import Notifications from './views/Notifications.vue';
import TaskCenter from './views/TaskCenter.vue';
import TrafficUsage from './views/TrafficUsage.vue';
import AuditLogs from './views/AuditLogs.vue';
import Health from './views/Health.vue';
import client from './api/client';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/login', component: Login, meta: { layout: 'auth' } },
    {
      path: '/',
      component: MainLayout,
      children: [
        { path: '', component: Dashboard },
        { path: 'nodes', component: Nodes },
        { path: 'health', component: Health },
        { path: 'proxies', component: Proxies },
        { path: 'proxy-users', component: ProxyUsers },
        { path: 'leaderboard', component: Leaderboard },
        { path: 'topology', component: Topology },
        // Merged page: shows each region's name, domains, IPs, and
        // game-server list, plus a "sync from regions.json" button
        // (replaces the old /regions + /region-lines split).
        { path: 'region-lines', component: RegionLines, alias: ['/regions'] },
        { path: 'settings', component: Settings },
        { path: 'notifications', component: Notifications },
        { path: 'task-center', component: TaskCenter },
        { path: 'traffic-usage', component: TrafficUsage },
        { path: 'audit-logs', component: AuditLogs },
        { path: 'plugins', redirect: '/nodes' },
      ],
    },
  ],
});

router.beforeEach(async (to, _from, next) => {
  if (to.path === '/login') return next();
  try {
    await client.get('/api/admin/me');
    next();
  } catch {
    next('/login');
  }
});

export default router;
